import { render } from "./Main.vue?vue&type=template&id=2e8a23c9"
const script = {}
script.render = render

export default script